import { DeclinedReason } from './declined-reason.model'
import { ServiceGroup } from './service-group.model';
import { WorkOrder } from './work-order.model';

export class WorkorderDeclinedMpviCode {
  associatedCase: number = null;
  campaignId: string = null;
  classificationId: number = null;
  comments: string = null;
  declinedAdditionalServiceReason: boolean = null;
  declinedFromGmWorkbench: boolean = null;
  declinedFromServiceSchedule: boolean = null;
  declinedReasonId: number = null;
  embedded?: WorkOrderDeclinedMpviCodeEmbed = null;
  id: number = null;
  inspectionTask: number = null;
  opCode: string = null;
  printFlag: boolean = null;
  sequence: number = null;
  workOrderId: number = null;

  constructor(obj?: WorkorderDeclinedMpviCode) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

class WorkOrderDeclinedMpviCodeEmbed {
  declinedReason?: DeclinedReason = null;
  serviceGroup?: ServiceGroup = null;
  workOrder?: WorkOrder = null;
}
